"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAYABLE_DOCUMENT_STATUSES = exports.PAYABLE_DOCUMENT_SAT_STATUSES = exports.PAYABLE_DOCUMENTS_RECONCILIATION_STATUSES = void 0;
var PAYABLE_DOCUMENT_STATUSES = exports.PAYABLE_DOCUMENT_STATUSES = ['DRAFT', 'AVAILABLE', 'USED', 'DELETED'];
var PAYABLE_DOCUMENT_SAT_STATUSES = exports.PAYABLE_DOCUMENT_SAT_STATUSES = ['NONE', 'VALID', 'INVALID', 'PENDING', 'FAILED'];
var PAYABLE_DOCUMENTS_RECONCILIATION_STATUSES = exports.PAYABLE_DOCUMENTS_RECONCILIATION_STATUSES = ['PENDING', 'RECONCILIATED', 'ALL'];